const supplementaryUploadExtensions = Object.freeze([
  '.pdf',
  '.docx',
  '.pptx',
  '.xlsx',
  '.png',
  '.jpg',
  '.jpeg',
]);
const supplementaryUploadAccept = supplementaryUploadExtensions.join(',');
const supplementaryUploadHelpText = 'Supported files: PDF, DOCX, PPTX, XLSX, PNG, JPG, and JPEG.';
const supplementaryTableColumnLabels = Object.freeze({
  actions: 'Actions',
  document: 'Document',
  type: 'Type',
  source: 'Source',
  extraction: 'Extraction',
  indexedAt: 'Indexed At',
});

const createSupplementaryUploadFormData = (file) => {
  const formData = new FormData();
  formData.append('File', file);
  return formData;
};

const isSupportedSupplementaryUpload = (fileName) => {
  if (typeof fileName !== 'string') return false;
  const normalizedName = fileName.trim().toLowerCase();
  return supplementaryUploadExtensions.some((extension) => normalizedName.endsWith(extension));
};

const getSupplementarySourceTypeLabel = (value) =>
  value === 'upload' ? 'Supplementary Upload' : value;

export {
  createSupplementaryUploadFormData,
  getSupplementarySourceTypeLabel,
  isSupportedSupplementaryUpload,
  supplementaryTableColumnLabels,
  supplementaryUploadAccept,
  supplementaryUploadExtensions,
  supplementaryUploadHelpText,
};
